import { Directive, effect, ElementRef, inject, input } from '@angular/core';

@Directive({
  selector: '[shared-ui-key-info]',
})
export class KeyInfo {
  host: ElementRef<HTMLElement> = inject(ElementRef);
  readonly info = input.required<string>();

  constructor() {
    effect(() => {
      this.host.nativeElement.setAttribute('data-key', this.info());
    });
  }
}
